/** @format */

import React, { Fragment } from "react";
import PropTypes from "prop-types";

const SvgSelector = ({ type }) => {
	let code;
	switch (type) {
		case "bug":
			code = (
				<svg
					width='437'
					height='512'
					viewBox='0 0 437 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M304.198 0.501279C304.571 -0.0304369 305.303 -0.159658 305.835 0.212654L342.189 25.6682C342.721 26.0405 342.85 26.7733 342.478 27.305L291.879 99.5673C316.478 107.426 333.237 115.903 333.237 115.903C333.237 115.903 292.273 186.365 222.794 186.365C153.315 186.365 103.944 120.693 103.944 120.693C103.944 120.693 121.45 109.521 147.4 99.9391L91.9 33.7976C91.483 33.3003 91.548 32.559 92.045 32.1418L126.042 3.61465C126.54 3.19742 127.281 3.26227 127.698 3.75952L197.97 87.5064C203.987 86.8258 210.117 86.4454 216.303 86.4454C225.194 86.4454 234.074 87.1213 242.743 88.2683L304.198 0.501279ZM317.944 189.702C336.485 176.46 364.541 141.898 364.541 141.898C364.541 141.898 436.205 198.688 436.205 319.104C436.205 439.519 312.309 511.992 312.309 511.992C312.309 511.992 253.114 452.211 238.582 376.43C224.051 300.649 260.078 216.503 260.078 216.503C260.078 216.503 299.402 202.944 317.944 189.702ZM118.261 189.702C99.72 176.46 71.664 141.898 71.664 141.898C71.664 141.898 0 198.688 0 319.104C0 439.519 123.896 511.992 123.896 511.992C123.896 511.992 183.091 452.211 197.623 376.43C212.154 300.649 176.127 216.503 176.127 216.503C176.127 216.503 136.803 202.944 118.261 189.702Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "dark":
			code = (
				<svg
					width='512'
					height='512'
					viewBox='0 0 512 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M229.723 452.85C239.45 454.339 249.412 455.111 259.556 455.111C367.558 455.111 455.111 367.558 455.111 259.556C455.111 151.553 367.558 64 259.556 64C252.31 64 245.155 64.3941 238.114 65.1621C291.689 105.751 327.111 176.062 327.111 256C327.111 340.04 287.96 413.44 229.723 452.85ZM256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "dragon":
			code = (
				<svg
					width='448'
					height='512'
					viewBox='0 0 448 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M248.702 254.881C252.172 252.765 255.116 248.331 257.49 243.403C288.735 256.173 310.692 286.349 310.692 321.54C310.692 368.29 271.942 406.189 224.142 406.189C204.52 406.189 186.423 399.802 171.906 389.039C167.144 386.784 163.226 384.618 160.02 382.845C155.047 380.096 151.786 378.293 149.744 378.575C143.775 379.398 145.508 384.89 147.083 389.879C148.152 393.268 149.149 396.425 147.606 397.727C145.992 399.091 140.764 394.106 134.655 388.282C126.339 380.353 116.391 370.868 111.7 373.717C107.991 375.97 111.592 382.081 116 389.561L116.327 390.116C118.189 393.278 120.347 396.498 122.316 399.436C126.319 405.407 129.543 410.219 127.93 411.033C125.98 412.017 112.394 402.847 100.945 390.116C96.526 385.203 92.246 379.877 88.268 374.928V374.927C79.561 364.093 72.307 355.068 68.235 356.137C63.3365 357.423 67.0421 367.527 72.487 377.25C75.033 381.797 78.028 386.427 80.621 390.436V390.437C84.654 396.671 87.715 401.402 86.605 401.984C85.107 402.767 71.926 389.914 62.9734 373.717C57.6559 364.096 53.1909 353.464 49.5761 344.857C45.656 335.522 42.7359 328.569 40.8131 327.869C34.1325 325.438 34.1325 339.059 36.8119 358.718C37.1614 361.283 37.6819 363.973 38.3228 366.712C64.307 450.785 144.128 512 238.567 512C354.084 512 447.728 420.412 447.728 307.432C447.728 199.9 362.899 111.747 255.12 103.494C255.256 98.4284 257.9 88.383 257.9 88.383C257.9 88.383 276.927 42.3472 277.933 32.5099C277.999 31.857 278.078 31.1475 278.163 30.3919C279.348 19.7629 281.553 0 264.551 0C255.471 0 251.249 6.75464 246.42 14.4799V14.48C244.566 17.4457 242.622 20.5545 240.28 23.479C223.412 44.5436 195.048 70.8488 178.965 84.8631C144.971 114.484 111.619 138.828 92.167 153.026L92.166 153.027C83.319 159.484 77.348 163.843 75.5 165.644C61.574 179.22 11.6418 269.286 11.6418 269.286C11.6418 269.286 -4.50569 298.182 1.23381 304.043C6.97331 309.903 20.8141 308.56 20.8141 308.56C20.8141 308.56 206.755 265.903 223.402 262.539C227.884 261.633 231.048 261.11 233.477 260.709C240.072 259.62 241.256 259.424 248.702 254.881ZM117.235 200.064C107.254 209.551 90.701 232.196 90.701 232.196C90.701 232.196 121.465 234.091 138.408 217.986C155.352 201.88 151.47 174.433 151.47 174.433C151.47 174.433 127.215 190.577 117.235 200.064Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "electric":
			code = (
				<svg
					width='320'
					height='511'
					viewBox='0 0 320 511'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M56.1196 0.583659C56.0206 0.29796 56.2336 0 56.5356 0H236.365C236.558 0 236.729 0.125587 236.786 0.309782L319.384 267.171C319.471 267.454 319.26 267.741 318.963 267.741H199.244C199.098 267.741 198.993 267.88 199.033 268.021L267.695 509.726C267.829 510.195 267.214 510.501 266.921 510.111L0.0890971 155.267C-0.128903 154.977 0.0779909 154.563 0.440591 154.563H109.096C109.247 154.563 109.353 154.414 109.303 154.271L56.1196 0.583659Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "fairy":
			code = (
				<svg
					width='512'
					height='512'
					viewBox='0 0 512 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M102.726 405.978L184.848 382.166L255.778 511.857C255.871 512.025 256.112 512.025 256.204 511.857L327.134 382.166L409.257 405.978C409.441 406.031 409.612 405.86 409.557 405.676L385.741 325.179L511.856 256.204C512.025 256.112 512.025 255.871 511.857 255.779L384.702 186.235L409.557 102.225C409.612 102.041 409.441 101.87 409.257 101.923L325.208 126.294L256.204 0.126188C256.112 -0.0420597 255.871 -0.0420644 255.779 0.126184L186.775 126.294L102.726 101.923C102.542 101.87 102.371 102.041 102.426 102.225L127.281 186.235L0.126188 255.779C-0.0420597 255.871 -0.0420644 256.112 0.126184 256.204L126.241 325.179L102.426 405.676C102.371 405.86 102.542 406.031 102.726 405.978ZM166.452 256.876L224.631 288.695L256.45 346.873C256.542 347.042 256.784 347.042 256.876 346.873L288.695 288.695L346.873 256.876C347.041 256.784 347.041 256.542 346.873 256.45L288.695 224.631L256.876 166.453C256.784 166.284 256.542 166.284 256.45 166.453L224.631 224.631L166.452 256.45C166.284 256.542 166.284 256.784 166.452 256.876Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "fighting":
			code = (
				<svg
					width='478'
					height='512'
					viewBox='0 0 478 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M71.2336 42.5656C77.4299 18.1014 99.593 0 125.983 0C145.778 0 163.195 10.1847 173.279 25.6H189.792C200.051 15.0716 214.384 8.53333 230.245 8.53333C253.499 8.53333 273.471 22.5882 282.129 42.6667H295.954C304.617 37.2585 314.853 34.1333 325.818 34.1333C349.073 34.1333 369.044 48.1882 377.702 68.2667H415.297C415.618 68.2667 415.919 68.3532 416.178 68.5041C417.895 68.347 419.634 68.2667 421.391 68.2667C452.582 68.2667 477.866 93.5514 477.866 124.742V294.086L477.867 294.4L477.866 294.714V297.153C477.866 298.186 477.838 299.215 477.782 300.239C474.384 417.717 368.749 512 238.933 512C106.974 512 0 414.577 0 294.4C0 236.391 24.9249 183.683 65.5535 144.675C65.4522 201.228 66.4074 259.694 70.8107 258.691C82.6011 256.003 73.3891 80.8395 71.2336 42.5656Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "fire":
			code = (
				<svg
					width='384'
					height='512'
					viewBox='0 0 384 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M288.258 395.394C294.584 372.263 282.305 324.71 282.305 324.71C282.305 324.71 273.399 363.449 259.483 377.767C247.611 389.98 233.066 398.451 212.206 400.677C229.261 392.393 240.99 375.12 240.99 355.155C240.99 327.129 217.878 304.409 189.368 304.409C160.858 304.409 137.745 327.129 137.745 355.155C137.745 362.809 139.47 370.068 142.557 376.576C124.725 362.37 121.921 339.594 121.921 339.594C121.921 339.594 102.009 422.264 156.875 461.152C211.74 500.04 319.219 466.614 319.219 466.614C319.219 466.614 165.41 574.837 51.4361 457.05C-46.7431 355.584 25.8112 222.003 25.8112 222.003C25.8112 222.003 22.6778 234.395 22.6778 248.78C22.6778 263.165 30.4771 274.11 30.4771 274.11C30.4771 274.11 53.7421 225.071 71.8481 205.128C88.9841 186.254 110.465 170.946 129.019 157.724C143.301 147.546 155.849 138.604 163.343 130.223C204.62 84.0687 179.311 0 179.311 0C179.311 0 225.841 41.02 238.831 93.9978C243.783 114.192 240.597 137.169 237.749 157.716C233.125 191.072 229.388 218.025 262.793 216.276C316.775 213.449 269.866 130.223 269.866 130.223C269.866 130.223 392.318 194.583 383.17 307.145C374.021 419.707 249.324 445.297 249.324 445.297C249.324 445.297 281.931 418.525 288.258 395.394Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "flying":
			code = (
				<svg
					width='512'
					height='444'
					viewBox='0 0 512 444'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M178.712 443.733C253.715 443.733 317.927 402.048 344.436 342.956C344.76 342.235 238.007 370.699 241.411 360.637C242.931 356.144 308.371 332.238 356.048 304.354C383.451 288.327 396.07 254.4 396.07 254.4C396.07 254.4 349.903 276.815 326.564 282.501C279.532 293.961 238.131 292.727 238.131 291.533C238.131 288.951 306.876 275.889 402.424 217.664C447.367 190.277 459.574 143.103 459.574 143.103C459.574 143.103 410.163 172.535 380.293 182.252C309.457 205.295 244.815 212.239 244.815 209.121C244.815 202.445 301.702 186.802 362.016 157.577C393.376 142.382 420.535 122.53 452.008 100.453C503.506 64.332 511.999 0 511.999 0C511.999 0 461.207 32.7601 436.42 43.6394C334.141 88.531 243.829 112.079 178.712 117.177C80.416 124.873 0 193.456 0 282.501C0 371.547 80.0119 443.733 178.712 443.733Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "ghost":
			code = (
				<svg
					width='512'
					height='512'
					viewBox='0 0 512 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M368.952 510.227C322.769 512.591 269.896 512.591 251.928 510.227C111.77 491.788 0 389.313 0 250.8C0 112.287 114.615 0 256 0C397.385 0 512 112.287 512 250.8C512 315.221 487.207 373.969 446.46 418.387C435.395 430.448 450.577 438.908 466.002 447.504C481.13 455.935 496.492 464.496 487.564 476.712C477.726 490.173 424.392 507.389 368.952 510.227ZM220 219.45C220 241.092 202.091 258.637 180 258.637C157.909 258.637 140 241.092 140 219.45C140 204.935 148.055 192.264 160.024 185.491C160.713 204.362 176.229 219.449 195.269 219.449H220V219.45ZM343.976 185.491C343.287 204.362 327.771 219.449 308.731 219.449H284V219.45C284 241.092 301.909 258.637 324 258.637C346.091 258.637 364 241.092 364 219.45C364 204.935 355.945 192.264 343.976 185.491Z'
						fill='white'
					/>
				</svg>
			);
			break;

		case "grass":
			code = (
				<svg
					width='457'
					height='494'
					viewBox='0 0 457 494'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M73.2266 430.205C71.4692 428.552 69.7312 426.867 68.0134 425.149C-22.6711 334.465 -22.6711 187.436 68.0134 96.7516C158.698 6.0667 447.654 0 447.654 0C447.654 0 487.095 334.465 396.411 425.149C315.871 505.689 190.89 514.699 100.407 452.18L173.315 362.709L289.865 337.546L194.726 328.035L255.188 266.473L324.012 251.396L269.59 235.279L324.012 137.103L246.602 223.931L216.709 181.748L227.232 251.396L173.315 312.178L148.322 235.278V337.546L73.2266 430.205Z'
						fill='#fff'
					/>
				</svg>
			);
			break;

		case "ground":
			code = (
				<svg
					width='512'
					height='372'
					viewBox='0 0 512 372'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M112.764 369.754C112.625 369.754 112.528 369.617 112.574 369.486L243.289 0.134003C243.318 0.0537027 243.394 0 243.479 0H383.021C383.106 0 383.183 0.054103 383.211 0.134903L511.987 369.487C512.032 369.618 511.935 369.754 511.797 369.754H116.692H112.764ZM0.201306 371.199C0.0609122 371.199 -0.0362852 371.059 0.0129607 370.928L97.3526 111.056C97.3821 110.977 97.4571 110.925 97.541 110.925H182.118C182.258 110.925 182.355 111.064 182.307 111.195L88.1823 371.067C88.1535 371.146 88.0779 371.199 87.9932 371.199H0.201306Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "ice":
			code = (
				<svg
					width='500'
					height='437'
					viewBox='0 0 500 437'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M378.245 0.566528L379.82 138.917L259.15 196.844L257.662 66.2147L378.245 0.566528Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M499.211 218.572L379.755 286.899L260.229 218.464L379.694 155.712L499.211 218.572Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M238.981 218.572L119.526 286.899L0 218.464L119.464 155.712L238.981 218.572Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M118.184 0L242.17 61.4057L239 195.222L121.934 137.244L118.184 0Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M381.619 435.05L257.633 373.644L260.803 239.827L377.869 297.806L381.619 435.05Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M122.466 436.295L120.89 297.945L241.561 240.018L243.049 370.646L122.466 436.295Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "normal":
			code = (
				<svg
					width='450'
					height='450'
					viewBox='0 0 450 450'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M450 225C450 349.264 349.264 450 225 450C100.736 450 0 349.264 0 225C0 100.736 100.736 0 225 0C349.264 0 450 100.736 450 225ZM353.571 225C353.571 296.008 296.008 353.571 225 353.571C153.992 353.571 96.429 296.008 96.429 225C96.429 153.992 153.992 96.429 225 96.429C296.008 96.429 353.571 153.992 353.571 225Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "poison":
			code = (
				<svg
					width='512'
					height='512'
					viewBox='0 0 512 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M427.821 393.449C479.524 352.108 512 292.376 512 225.95C512 101.161 397.385 0 256 0C114.615 0 0 101.161 0 225.95C0 289.978 30.1737 347.786 78.6553 388.901C75.7171 399.046 74.1052 410.081 74.1052 421.62C74.1052 471.535 104.267 512 141.474 512C165.65 512 186.852 494.915 198.737 469.254C210.622 494.915 231.824 512 256 512C278.038 512 297.604 497.804 309.895 475.857C322.186 497.804 341.752 512 363.789 512C400.996 512 431.158 471.535 431.158 421.62C431.158 411.784 429.986 402.314 427.821 393.449ZM404.211 230.431C404.211 293.785 336.346 345.144 252.632 345.144C168.917 345.144 101.053 293.785 101.053 230.431C101.053 167.077 168.917 115.718 252.632 115.718C336.346 115.718 404.211 167.077 404.211 230.431Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "psychic":
			code = (
				<svg
					width='476'
					height='512'
					viewBox='0 0 476 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M437.925 425.184C437.925 425.184 373.365 476.963 244.893 455.536C147.423 439.279 95.437 331.833 95.437 274.079C95.437 137.149 196.783 105.988 265.3 105.988C333.816 105.988 378.513 172.788 378.513 224.508C378.513 276.228 341.933 321.466 285.006 321.466C228.08 321.466 211.22 281.501 211.22 244.758C211.22 208.016 240.947 195.071 268.058 195.071C295.169 195.071 304.452 218.217 304.452 238.11C304.452 258.004 289.017 265.128 276.143 265.128C263.269 265.128 261.996 258.633 257.069 251.807C252.141 244.982 263.353 219.146 244.893 219.146C226.433 219.146 222.992 248.847 222.992 248.847C222.992 248.847 229.722 306.18 285.006 305.191C340.291 304.201 366.518 261.461 358.896 219.146C351.274 176.83 310.207 131.865 238.133 140.951C166.059 150.037 136.632 222.861 149.603 300.685C162.574 378.51 255.807 423.602 329.112 407.379C402.418 391.156 475.429 338.086 475.429 203.533C475.429 68.9789 358.896 -11.9002 219.941 1.42914C80.9859 14.7584 -5.27102 136.242 0.250183 282.207C5.77138 428.172 144.275 507.669 261.394 511.766C378.513 515.864 450.312 448.067 450.312 448.067C450.312 448.067 466.459 433.668 460.128 422.424C453.798 411.18 437.925 425.184 437.925 425.184Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "rock":
			code = (
				<svg
					width='514'
					height='404'
					viewBox='0 0 514 404'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M396.138 190.757C396.109 190.717 396.097 190.667 396.105 190.618L428.769 0.151798C428.784 0.0640982 428.861 0 428.949 0H439.287C439.367 0 439.437 0.0517008 439.461 0.127701L513.051 233.131C513.074 233.203 513.049 233.283 512.989 233.33L458.73 275.693C458.649 275.756 458.532 275.74 458.471 275.657L396.138 190.757ZM0 317.022C0 317.101 0.050796 317.171 0.125891 317.196L111.975 353.767C112.029 353.785 112.089 353.776 112.136 353.744L362.145 181.144C362.187 181.115 362.215 181.07 362.222 181.02L389.032 1.1284C389.049 1.018 388.963 0.9188 388.852 0.9188H167.406C167.351 0.9188 167.3 0.943001 167.265 0.984901L0.042026 202.714C0.01486 202.747 0 202.788 0 202.831V317.022ZM158.583 363.085L280.776 403.112C280.831 403.13 280.892 403.121 280.939 403.087L426.418 298.734C426.499 298.677 426.519 298.566 426.464 298.484L371.928 217.329C371.871 217.244 371.757 217.222 371.673 217.28L158.583 363.085Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "steel":
			code = (
				<svg
					width='512'
					height='441'
					viewBox='0 0 512 441'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0.0511107 220.527C-0.0170046 220.411 -0.0170388 220.267 0.0510196 220.15L128.795 0.184299C128.862 0.0701995 128.985 0 129.117 0H384.294C384.427 0 384.55 0.0708016 384.617 0.185902L511.949 220.152C512.016 220.267 512.016 220.41 511.949 220.525L384.617 440.244C384.55 440.359 384.427 440.43 384.294 440.43H129.117C128.985 440.43 128.862 440.36 128.795 440.246L0.0511107 220.527ZM374.617 220.215C374.617 285.703 321.528 338.792 256.04 338.792C190.552 338.792 137.463 285.703 137.463 220.215C137.463 154.726 190.552 101.638 256.04 101.638C321.528 101.638 374.617 154.726 374.617 220.215Z'
						fill='white'
					/>
				</svg>
			);
			break;
		case "water":
			code = (
				<svg
					width='333'
					height='512'
					viewBox='0 0 333 512'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M332.172 346.515C332.172 437.897 257.813 511.977 166.086 511.977C74.359 511.977 0 437.897 0 346.515C0 257.639 157.102 13.5479 165.718 0.22781C165.915 -0.0759385 166.258 -0.0759358 166.454 0.227813C175.07 13.5479 332.172 257.639 332.172 346.515ZM138.4 458.931C54.12 440.49 68.542 347.13 68.542 347.13C68.542 347.13 91.556 403.488 147.405 421.744C203.253 439.999 270.745 413.225 270.745 413.225C270.745 413.225 222.68 477.371 138.4 458.931Z'
						fill='white'
					/>
				</svg>
			);
			break;

		default:
			code = (
				<svg
					width='20'
					height='20'
					viewBox='0 0 20 20'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM15 11H5V9H15V11Z'
						fill='white'
					/>
				</svg>
			);
			break;
	}

	return (
		<Fragment>
			<div className='svg-icon' data-type={type}>
				{code}
			</div>
		</Fragment>
	);
};

SvgSelector.propTypes = {
	type: PropTypes.string.isRequired
};

export default SvgSelector;
